import { PostHogProvider} from 'posthog-js/react'
import { CONSTANTS } from '../../constants'

// Analytics is ON unless a build explicitly turns it off with REACT_APP_ANALYTICS=off.
// Production sets nothing and is therefore unchanged.
//
// This gate exists because POSTHOG_KEY is hardcoded to the PRODUCTION project key, so any
// deployment built from this source — demo, dev, a laptop — reports into the same project and
// mixes test traffic into real analytics. There is no runtime escape either: the consent modal
// (PostHogConfirmation) is commented out in index.js, so nothing ever calls opt_out_capturing().
// Non-production deployments must therefore be gated at BUILD time.
const ANALYTICS_ENABLED = String(process.env.REACT_APP_ANALYTICS || '').toLowerCase() !== 'off'

const options = {
  api_host: CONSTANTS.POSTHOG_HOST,
  autocapture: true,
  capture_pageview: true,
  session_recording: {
    enabled: false,
  }
}

const PostHogProviderContainer = ({children}) => {
  // Render children without the provider: posthog-js never initializes, so there is no
  // cookie, no distinct_id and no events.
  if (!ANALYTICS_ENABLED) return children

  return (
    <PostHogProvider apiKey={CONSTANTS.POSTHOG_KEY} options={options}>{children}</PostHogProvider>
  )
}

export default PostHogProviderContainer
